import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, CircularProgress, Menu, MenuItem, Pagination, Skeleton, TextField } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import api from '../../api/api'
import { useSelector } from 'react-redux'
import Swal from 'sweetalert2'
export default function ProductionPlan() {
    const fileRef = useRef()

    const [data, setData] = useState([])
    const [searchParams, setSearchParams] = useSearchParams()
    let q = searchParams.get('q') || ''
    let page = searchParams.get('page') || '1'
    // const [documentNo, setDocumentNo] = useState('')
    // const [page, setPage] = React.useState(1);
    const navigate = useNavigate();
    const { profile } = useSelector(state => state.profile)

    const [rowsData, setRowsData] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingPDF, setLoadingPDF] = useState(false);
    const [importExcel, setImportExcel] = useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event, item) => {
        setRowsData(item)
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const getData = async () => {
        setLoading(true)
        const res = await api.get(`plan/productions?documentNo=${q}`)
        const data = await res.data.result
        if (res.data.status === true) {
            setData(data)
            setLoading(false)
        }
    }
    useEffect(() => {
        getData()
    }, [q])
    const handleStatus = async (documentNo, status) => {
        const res = await api.put(`plan/productions/${documentNo}/status?status=${status}`)
        const data = await res.data.result
        if (res.data.status === true) {
            getData()
        }
    }
    const linkToDetail = (plan, mode, version) => {
        if (plan && mode) {
            navigate(`/plan/production-plan/${plan?.DocumentNo}?mode=${version === 0 ? 'plan' : 'review'}&version=${version}`)
        } else {
            navigate('/plan/production-plan/add' +
                '?mode=' + mode
            )
        }

    }
    async function importProductions(_file) {

        const frmData = new FormData();
        frmData.append('file', _file);
        const res = await api.post(`plan/import-productions`, frmData)
        const data = await res.data.result
        if (res.data.status === true) {
            Swal.fire({
                title: 'อัพโหลดสำเร็จ',
                icon: 'success',
            })
            getData()
        }
        // const res = await getImportReserves(frmData);
        // if (res.length > 0) {
        //     Swal.fire({
        //         title: 'ทำรายการสำเร็จ',
        //         icon: 'success',
        //     })
        //     const creds = [];

        //     for (const c of res) {
        //         const _qty = (c?.Qty || 0);
        //         const totalPrice = (c?.ItemNo?.SalePrice) * (_qty);
        //         const _freight = !c?.Freight ? _qty : c?.Freight;
        //         creds.push({

        //         });
        //         setRows(creds)

        //         // this.initSearch(creds.length - 1);
        //         // this.initCalculate(creds.length - 1);
        //     }
        // }

    }


    async function uploadFile(event) {

        setImportExcel(true)
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            const fileUpload = file;
            if (fileUpload?.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                setImportExcel(false)
                return alert('กรุณาอัพโหลดไฟล์ excel');
            }

            await importProductions(fileUpload);
        }
        event.target.value = '';
        setImportExcel(false)
    }
    async function downloadFile(documentNo) {
        const item = data?.map((x, i) => ({
            ...x,
            loading: documentNo === x?.DocumentNo && true
        }))
        setData(item)
        const res = await api.get(`plan/productions/${documentNo}/pdf`, {
            responseType: 'arraybuffer'
        })
        const buffer = res.data
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        const item2 = data?.map((x, i) => ({
            ...x,
            loading: documentNo === x?.DocumentNo && false
        }))
        setData(item2)
    }

    return (
        <Page>
            <div class="container-fluid">

                <div class=" d-flex row justify-content-between align-items-baseline">
                    <div class="col-lg-4 col-md-12 text-left ">
                        <label class="title-content mb-4">
                            รายการแผนการผลิต/ทบทวน
                        </label>
                    </div>
                    <div class="col-lg-4 col-md-12 text-end px-4">


                    </div>
                    <div class="col-lg-4 col-md-12 d-flex">
                        {profile?.BranchNo?.BranchNo === '00' &&
                            <>
                                <Box className='backgroundField' sx={{ width: "100%" }}>
                                    <TextField value={q} onChange={e => setSearchParams({ q: e.target.value })} variant="standard" fullWidth placeholder="ค้นหา เลขที่เอกสาร"
                                        InputProps={{
                                            disableUnderline: true,
                                            startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                        }}
                                    />
                                </Box>
                                <input
                                    type="file" ref={fileRef} accept=".xlsx,.csv,.xls" hidden onChange={uploadFile} />
                                <Button onClick={() => fileRef.current.click()} type="button" className="ButtomSearch" variant='contained' sx={{ marginLeft: "20px", width: '212px' }}>นำเข้าแผนการผลิต</Button>
                            </>}

                    </div>
                </div>

                <div class="listData row">
                    {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                        <div class="col-md-12 table-responsive-sm pb-3">
                            <table class="table table-borderless table-hover ">
                                <thead>
                                    <tr>
                                        {/* <th class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th> */}
                                        <th class="text-center">เลขที่หนังสือ</th>
                                        <th class="text-center">ประจำปี</th>
                                        {/* <th class="text-center">ฤดู</th> */}
                                        <th class="text-center">หมายเหตุ</th>
                                        <th class="text-center">สถานะ</th>
                                        {/* <th class="text-center">สถานะ</th>
                                    <th class="text-center">สถานะทบทวน</th> */}
                                        <th class="text-center">ดำเนินการ</th>
                                    </tr>
                                </thead>
                                <tbody class="cp">
                                    {data?.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)?.map((x, i) => (
                                        <tr >
                                            {/* <td class="text-center">{x?.BranchNo?.BranchName}</td> */}
                                            <td class="text-center">{x?.RefNo}</td>
                                            <td class="text-center">{x?.Year}</td>
                                            {/* <td class="text-center">{x?.Season}</td> */}
                                            <td class="text-center">{x?.Remark || '-'}</td>
                                            <td class="text-center" style={{
                                                color:x?.Status === 'Y' ? 'green' : 'red'
                                            }}>{x?.Status === 'Y' ? 'ปกติ' : 'ยกเลิก'}</td>
                                            {/* <td class="text-center">
                                            <span class="status-active">
                                                ใช้งาน
                                            </span>

                                        </td>
                                        <td class="text-center">
                                            {x?.ReviewStatus === 'D' ?
                                                <span class="status-inactive">
                                                    ไม่อนุมัติ ({x?.Version})
                                                </span> : x?.ReviewStatus === 'Y' ?
                                                    <span class="status-active">
                                                        อนุมัติ ({x?.Version})
                                                    </span> : x?.ReviewStatus === 'W' ?
                                                        <span class="status-wait">
                                                            รอการอนุมัติ ({x?.Version})
                                                        </span> : x?.ReviewStatus === 'N' ?
                                                            <span class="status-draft">
                                                                ยังไม่มีการขอทบทวน
                                                            </span> : ''}
                                        </td> */}
                                            <td class="text-center">
                                                <div>
                                                    {profile?.BranchNo?.BranchNo === '00' && <Button variant='contained' sx={{ background: x?.Status === 'Y' ? 'green' : 'red', ':hover': { background: x?.Status === 'Y' ? 'green' : 'red' } }}
                                                        onClick={e =>
                                                            handleStatus(x?.DocumentNo, x?.Status === 'Y' ? 'N' : 'Y')
                                                        }>{x?.Status === 'Y' ? 'เปิดการใช้งาน' : 'ปิดการใช้งาน'}</Button>}
                                                    {/* <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}
                                                        onClick={e =>
                                                            navigate(`/plan/production-plan/${x?.DocumentNo}`)
                                                            // handleClick(e, x)
                                                        }>เรียกดู</Button> */}
                                                    {x?.RefFilePath &&
                                                        <Button variant='contained' disabled={x?.loading} sx={{ background: '#fbbe66', marginLeft: "10px", width: '120px', ':hover': { background: '#eda844' } }}
                                                            onClick={e => { downloadFile(x?.DocumentNo) }
                                                            }>{x?.loading ? <CircularProgress size={'22px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>}

                                                    {/* {x?.Version !== 5 &&
                                                    <Link to={`/plan/production-plan/${x?.DocumentNo}?mode=review`}>
                                                        <Button variant='contained' sx={{ background: '#fbbe66', marginLeft: '10px', ':hover': { background: '#eda844' } }}>ทบทวนเเผน</Button>
                                                    </Link>} */}
                                                </div>
                                            </td >


                                        </tr >
                                    ))}

                                </tbody >
                            </table >
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}

                            >
                                {rowsData?._Versions?.map((y) => <>
                                    {y?.Version === 0 ? <MenuItem onClick={() => {
                                        linkToDetail(rowsData, 'plan', y?.Version)
                                    }}>แผนการผลิต</MenuItem> : <MenuItem onClick={() => {
                                        linkToDetail(rowsData, 'review', y?.Version)
                                    }}>{`แผนการทบทวน (${y?.Version})`}
                                        {y.Status === 'Y' && <span style={{ marginLeft: '10px' }} class="status-active">
                                            อนุมัติ
                                        </span>}
                                        {y.Status === 'W' && <span style={{ marginLeft: '10px' }} class="status-wait">
                                            รอการอนุมัติ
                                        </span>}
                                        {y.Status === 'N' && <span style={{ marginLeft: '10px' }} class="status-inactive">
                                            ไม่อนุมัติ
                                        </span>}
                                    </MenuItem>
                                    }</>)}

                            </Menu>
                        </div >}
                    <div class="col-md-12 text-center mt-4">
                        <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={Math.ceil(data.length / rowsPerPage)} page={+page} onChange={(event, value) => setSearchParams({ page: value, q: q })} shape="rounded" />

                    </div >
                </div >
            </div >
        </Page >
    )
}
